import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { GetProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import loadProductInfoList from "@waytek/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";

interface Parameter {
    widgetId: string;
    purchaseType: string;
    page: number;
    pageSize: number;
    isOrderHistory?: boolean;
    parameter?: any;
}

interface Props {
    getProductCollectionParameter?: GetProductCollectionApiV2Parameter;
    products?: ProductModel[];
    productInfos?: ProductInfo[];
}

type HandlerType = Handler<Parameter, Props>;

export const LoadRecentlyPurchased: HandlerType = props => {
    if (props.parameter.purchaseType !== "recently") {
        return;
    }

    props.getProductCollectionParameter = {
        filter: "recentlyPurchased",
        expand: ["properties"],
        page: props.parameter.page,
        pageSize: props.parameter.pageSize,
    };
};

export const LoadFrequentlyPurchased: HandlerType = props => {
    if (props.parameter.purchaseType !== "frequently") {
        return;
    }

    props.getProductCollectionParameter = {
        filter: "frequentlyPurchased",
        expand: ["properties"],
        page: props.parameter.page,
        pageSize: props.parameter.pageSize,
    };
};

export const LoadProducts: HandlerType = props => {
    const {
        getProductCollectionParameter,
        dispatch,
        parameter: { widgetId: id },
    } = props;
    if (!getProductCollectionParameter) {
        return false;
    }

    if (props.parameter.isOrderHistory) {
        (getProductCollectionParameter as any).isOrderHistory = props.parameter.isOrderHistory;

        // productErpNumber
        if (props.parameter.parameter && props.parameter.parameter.productErpNumber) {
            (getProductCollectionParameter as any).erpNumber = props.parameter.parameter.productErpNumber;
        }

        // poNumber
        if (props.parameter.parameter && props.parameter.parameter.poNumber) {
            (getProductCollectionParameter as any).poNumber = props.parameter.parameter.poNumber;
        }

        if (props.parameter.parameter && props.parameter.parameter.orderNumber) {
            (getProductCollectionParameter as any).orderNumber = props.parameter.parameter.orderNumber;
        }

        // fromDate
        if (props.parameter.parameter && props.parameter.parameter.fromDate) {
            (getProductCollectionParameter as any).fromDate = props.parameter.parameter.fromDate;
        }

        // toDate
        if (props.parameter.parameter && props.parameter.parameter.toDate) {
            (getProductCollectionParameter as any).toDate = props.parameter.parameter.toDate;
        }

        // orderTotalOperator
        if (props.parameter.parameter && props.parameter.parameter.orderTotalOperator) {
            (getProductCollectionParameter as any).orderTotalOperator = props.parameter.parameter.orderTotalOperator;
        }

        // orderTotal
        if (props.parameter.parameter && props.parameter.parameter.orderTotal) {
            (getProductCollectionParameter as any).amount = props.parameter.parameter.orderTotal;
        }

        //  status
        if (props.parameter.parameter && props.parameter.parameter.status) {
            (getProductCollectionParameter as any).status = props.parameter.parameter.status;
        }

        // shipTo
        if (props.parameter.parameter && props.parameter.parameter.shipTo) {
            (getProductCollectionParameter as any).shipTo = props.parameter.parameter.shipTo;
        }
    }

    dispatch(
        loadProductInfoList({
            getProductCollectionParameter,
            id,
        }),
    );
};

export const chain = [LoadRecentlyPurchased, LoadFrequentlyPurchased, LoadProducts];

const loadPurchasedProducts = createHandlerChainRunner(chain, "LoadPurchasedProducts");
export default loadPurchasedProducts;
